import axios from '@/utils/request';

// 点赞
export const addLikes = (data: any) => {
  return axios.request({
    url: 'Likes/AddLikes',
    method: 'POST',
    data,
  });
};

// 取消点赞
export const cancelLikes = (data: any) => {
  return axios.request({
    url: 'Likes/CancelLikes',
    method: 'POST',
    data,
  });
};
